import React from 'react'
import { fnum } from '../../utils/utils'

export default class SmetaPostItem extends React.Component {
  
  render() {

    const { data, num } = this.props;
    return (
      <tr>
        <td>{num}</td>
        <td>{data.post_desc}</td>
        <td className="text-right">{fnum(data.post_price)}</td>
        <td className="text-right">{fnum(data.post_qntt)}</td>
        <td className="text-right">{fnum(data.post_price*data.post_qntt)}</td>
      </tr>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/smeta/SmetaPostItem.js